import React from 'react';
import "../styles/minting.css";
import config from '../config';
// import logo from '../assets/logo.png';

const MintPage = () => {

  // console.log("newUrl:" + config.embedUrl); 

  return (
    <div className='mintPage'>
      {/* <div className='maintenancediv'>
        <img src={logo} alt='logo'></img>
        <h1 id='maintenancetext'>Under Maintenance,<br></br> please come back later.</h1>
      </div> */}
      
      <iframe
        src={config.embedUrl}
        width="100%"
        height="100%"
        title='NFTDrop'
      ></iframe>
    </div>
  )
}

export default MintPage